
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#112A46","fill-opacity":".1"}}),_c('path',{attrs:{"d":"M8.108 18.307c-.177 1.162.615 1.968 1.585 2.37 3.72 1.54 8.895 1.54 12.614 0 .97-.402 1.762-1.208 1.585-2.37-.11-.714-.648-1.308-1.047-1.889-.522-.77-.574-1.609-.574-2.502 0-3.452-2.808-6.25-6.271-6.25s-6.27 2.798-6.27 6.25c0 .893-.053 1.733-.575 2.502-.4.581-.938 1.175-1.047 1.89z","stroke":"#112A46","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.667 21.832c.382 1.438 1.73 2.5 3.333 2.5 1.604 0 2.951-1.062 3.333-2.5","stroke":"#112A46","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    